import { RefObject, useEffect, useState } from 'react';

interface Options {
    threshold?: number;
    rootMargin?: string;
}

// Hook from: https://usekit.kiron.dev/docs/hooks/use-in-view
export const useInView = (
    ref: RefObject<HTMLElement | null>,
    { threshold = 0, rootMargin = '0px' }: Options = {},
): boolean => {
    const [isInView, setIsInView] = useState(false);

    useEffect(() => {
        if (!ref.current) return;

        const currentElement = ref.current;

        const observer = new IntersectionObserver(([entry]) => setIsInView(entry.isIntersecting), {
            threshold,
            rootMargin,
        });

        observer.observe(currentElement);
        return () => observer.unobserve(currentElement);
    }, [ref, threshold, rootMargin]);

    return isInView;
};
